t = require('views/internal/teacup-with-helpers')('boards_sidebar')

module.exports = t.renderable ->
  t.a '.quiet-button.js-add-board', { href: '#' }, ->
    t.format 'create-new-board-ellipsis'

  t.a '.quiet-button.hide.js-pin', { href: '#' }, ->
    t.format 'always-keep-this-menu-open'

  t.a '.quiet-button.hide.js-unpin', { href: '#' }, ->
    t.format 'don-t-keep-this-menu-open'

  t.a '.quiet-button.js-open-closed-boards', { href: '#' }, ->
    t.format 'see-closed-boards-ellipsis'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/boards_sidebar_boards_buttons.coffee